export function validateIndexValue(value: string) {
  if (value === '') {
    throw new Error('Invalid index value. Value cannot be blank.');
  } else if (value.length > 255) {
    throw new Error('Invalid index value. Must be 255 characters or less.');
  }
}
